import React, { useState } from 'react';
import { rightChevron } from 'assets';
import { BackPage, Modal } from 'components';
import { AccountPageContent } from 'services/content';
import { AUTH_LOGOUT } from 'helpers/types';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import styles from './styles.module.css';

const linkGroups = [
  [
    {
      name: 'Order Reminders',
      route: '/pharmacy/dashboard/order-reminder',
      internal: true,
      restrictRenderForBasicUser: true,
    },
    {
      name: 'Notification Permissions',
      route: '/pharmacy/dashboard/notification-permissions',
      internal: true,
      restrictRenderForBasicUser: false,
    },
    {
      name: 'Payment Methods',
      route: '/pharmacy/dashboard/payment?view=account',
      internal: true,
      restrictRenderForBasicUser: true,
    },
    {
      name: 'Delivery Details',
      route: '/pharmacy/dashboard/delivery-details?view=account',
      internal: true,
      restrictRenderForBasicUser: true,
    },
    {
      name: 'Exemption',
      route: '/pharmacy/dashboard/exemption?view=account',
      internal: true,
      restrictRenderForBasicUser: true,
    },
  ],
  [
    {
      name: 'Help & Support',
      route: 'https://intercom-help.eu/heypharmacist/en',
      internal: false,
      restrictRenderForBasicUser: false,
    },
  ],
  [
    {
      name: 'Terms & Conditions',
      route: '/terms-and-conditions',
      internal: false,
      restrictRenderForBasicUser: false,
    },
    { name: 'Privacy Policy', route: '/privacypolicy', internal: false, restrictRenderForBasicUser: false },
    {
      name: 'NHS login settings',
      route: '/pharmacy/dashboard/nhs-settings',
      internal: true,
      restrictRenderForBasicUser: true,
    },
  ],
];

const AccountLink = ({ link, setModalOpen, patientType }) => {
  const { internal, name, route, restrictRenderForBasicUser } = link;

  if (patientType.toLowerCase() === 'basic' && restrictRenderForBasicUser) {
    return (
      <button onClick={setModalOpen} data-testid="basic">
        <h2 className={styles.accountLinkTitle}>{name}</h2>
        <img src={rightChevron} alt="right chevron" />
      </button>
    );
  } else {
    if (internal) {
      return (
        <div data-testid="internal">
          <Link to={route}>
            <h2 className={styles.accountLinkTitle}>{name}</h2>
            <img src={rightChevron} alt="right chevron" />
          </Link>
        </div>
      );
    } else {
      return (
        <a href={route} target={'_blank'} rel="noopener noreferrer">
          <h2 className={styles.accountLinkTitle}>{name}</h2>
          <img src={rightChevron} alt="right chevron" />
        </a>
      );
    }
  }
};

const Account = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);

  let patientType = useSelector((state) => state.patient.patientType);

  const logout = () => {
    dispatch({ type: AUTH_LOGOUT });
    history.push('/pharmacy/login');
  };

  return (
    <BackPage onBackClick={() => history.push('/pharmacy/dashboard')} bplg="7">
      {modalOpen && (
        <Modal onClick={() => setModalOpen(false)}>
          <h2>{AccountPageContent.modal.headerText}</h2>
          <p>{AccountPageContent.modal.subHeadingText1}</p>
          <p>{AccountPageContent.modal.subHeadingText2}</p>
          <button className={`${styles.ctaButton} coop-btn coop-btn--primary`} onClick={() => setModalOpen(false)}>
            {AccountPageContent.modal.buttonText}
          </button>
        </Modal>
      )}
      <h1 className={styles.accountTitle}>My Account</h1>
      {linkGroups.map((linkGroup, i) => (
        <ul key={i.toString()} className={`${styles.accountLinkGroup} drop-shadow`}>
          {linkGroup.map((link, index) => (
            <li key={link.route}>
              <AccountLink patientType={patientType} link={link} setModalOpen={() => setModalOpen(true)} />
            </li>
          ))}
        </ul>
      ))}
      <button onClick={logout} className="coop-btn coop-btn--primary">
        Sign out
      </button>
    </BackPage>
  );
};

export default Account;
